var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root"},[_c('div',[_vm._v("QuizView")]),_c('br'),_c('ButtonPlain',{attrs:{"label":"Cheat"},on:{"click":function($event){return _vm.cheat()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }